import { useState } from 'react';

interface BossIconProps {
  slug: string;
  name: string;
}

/** Icons render at 48px everywhere — matches the 48x48 assets in public/bosses/. */
const SIZE_PX = 48;
const SIZE_CLASS = 'size-12';

/**
 * Same-origin boss icon (see `frontend/scripts/fetch-boss-icons.mjs` for how
 * `public/bosses/<slug>.png` gets populated — 48x48 Maple Guide icons from the MapleStory Wiki).
 * Falls back to a letter tile — same footprint, no layout shift — for any boss the fetch script
 * has no art for (`showa-minor-bosses`), or if the file 404s for any other reason.
 * Decorative: the boss name is always adjacent text, so `alt=""`.
 */
export function BossIcon({ slug, name }: BossIconProps) {
  const [failed, setFailed] = useState(false);

  if (failed) {
    const initial = name.trim().charAt(0).toUpperCase() || '?';
    return (
      <span
        aria-hidden="true"
        className={[
          SIZE_CLASS,
          'flex shrink-0 items-center justify-center rounded-lg bg-bg-elevated-hover font-display text-sm font-semibold text-text-faint',
        ].join(' ')}
      >
        {initial}
      </span>
    );
  }

  return (
    <img
      src={`/bosses/${slug}.png`}
      alt=""
      loading="lazy"
      width={SIZE_PX}
      height={SIZE_PX}
      className={[SIZE_CLASS, 'shrink-0 rounded-lg bg-bg-elevated-hover object-contain'].join(' ')}
      onError={() => setFailed(true)}
    />
  );
}
